<template>
	<div class="container mx-auto px-5 pt-4">
		<slot></slot>
	</div>
</template>

<script>
export default {};
</script>

<style></style>
